export const LOGIN_MODAL_ID = 'LOGIN_MODAL_ID'
export const SIGNUP_MODAL_ID = 'SIGNUP_MODAL_ID'
export const EMAIL_SIGNUP_MODAL_ID = 'EMAIL_SIGNUP_MODAL_ID'
export const FORGOT_PASSWORD_MODAL_ID = 'FORGOT_PASSWORD_MODAL_ID'
export const EMAIL_LOGIN_MODAL_ID = 'EMAIL_LOGIN_MODAL_ID'
export const CHANGE_SCHOOL_MODAL_ID = 'CHANGE_EDUCATIONAL_FACILITY_MODAL_ID'
export const DELETE_PROFILE_MODAL_ID = 'DELETE_PROFILE_MODAL_ID'
